import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../analytics';

export default function usePageTracking() {
  const location = useLocation();
  const page = location.pathname + location.search;

  // Depend on the string, not the location object — hash-only changes
  // (in-page anchors) re-create the object and would inflate page_view.
  useEffect(() => {
    trackPageView(page, document.title);
  }, [page]);
}
